export class AdviseeSummaryRequest {
    constructor() {
        this.status = 'INITIALIZING';
    }
}
//# sourceMappingURL=adviseeSummaryRequest.js.map